<template>
    <div>
        <codemirror :options="options" :class="'card'" v-model="tmplContent" @input="stringAnalysis" style="margin-bottom: 0"/>
        <div class="mb-3 flex-display">
            <div></div>
            <div class="font-weight-semibold ml-auto">
                <div class="text-right mt-2 mb-2">
                    <span class="font-weight-semibold">{{totalTextCharCnt}} character</span>
                </div>
                <div v-for="(message,index) in validationResult" :key="'codemirror'+index" class="text-right">
                    <span class="font-weight-semibold text-danger">{{message}}</span>
                </div>
            </div>
        </div>
        <legend v-if="params.length > 0" class="text-uppercase font-size-sm font-weight-bold">Options</legend>
        <div class="form-group row mb-1" v-for="(param,index) in params" :key="'smsSendModal_'+index">
            <div class="col-12">
                <div class="input-group">
                    <span class="input-group-prepend">
                        <span class="input-group-text">{{param.paramKey}}</span>
                    </span>
                    <input type="text" class="form-control" :key="'mailSendModal_'+index" @input="parametersTextChange" :data-value="param.value" :ref="'mailSendInput'+param.paramKey">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {codemirror,CodeMirror} from 'vue-codemirror'
    import 'codemirror/lib/codemirror.css'
    import contentEditorMixin from "@/config/mixin/contentEditorMixin";
    import CONST from '@/config/const/const'
    CodeMirror.defineMode('customMailmode', () => {
        return {
            token(stream, state) {
                if (stream.match(CONST.REGEX.EDITOR)) {
                    return "style-param"
                } else {
                    stream.next()
                    return null
                }
            }
        }
    })
    export default {
        name: "AppContentEditor",
        components: {
            codemirror,
        },
        mixins:[contentEditorMixin],
        props: {
            rule: {
                type:String
            },
            value: {
                type:Object
            },
        },
        data() {
            return {
                // regex: /%([1-9]{1,1})%/g,
                // regex:/{{([1-9]{1,1})(\:)([S|A|T|D|H])(\:DDMMYYYY)?(\:MMHH24DDMMYYYY)?(\:MMHH24)?}}/g,
                regex:CONST.REGEX.STRING_ANALYSIS,
                params:[],
                validationResult: [],
                tmplContent:'',
                maxCharCount: 160,
                options: {
                    tabSize: 4,
                    mode: 'customMailmode',
                    theme: 'base16-dark',
                    lineNumbers: true,
                    line: true,
                    lineWrapping: true,
                },
                parametersTextCount:0,
            }
        },
        computed: {
            plainTextCount: function() {
                return this.$filters.characterByte(this.tmplContent.replace(this.regex,' '))
            },
            totalTextCharCnt: function() {
                return this.plainTextCount + this.parametersTextCount
            },
        },
        methods: {
            parametersTextChange: function(e) {
                this.parametersTextCount = this.params.reduce((base,item)=> {
                    if(this.$refs['mailSendInput'+item.paramKey]) {
                        base += this.$refs['mailSendInput'+item.paramKey][0].value.length * item.duplParamCnt
                    }
                    return base
                },0)
            },
            validator: function() {
                this.validationResult = []
                if(this.isParamsDuplicated(this.params.map(item=>item.paramKey))) this.validationResult.push('Parameter keys cannot be duplicated')
                if(this.params.length > this.value.paramCnt) this.validationResult.push('The maximum number of parameters is '+this.value.paramCnt)
                if(this.totalTextCharCnt === 0) this.validationResult.push('This input is required.')
                return this.validationResult
            },
        },
        watch: {
            'totalTextCharCnt': function() {
                this.validator()
            },
            'value': function(val) {
                this.changeData(val)
            },
            'params': function() {
                this.parametersTextCount = 0
            }
        }
    }
</script>

<style scoped>

</style>

